import { Grid } from '@mui/material'
import { Campaign } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { useMemo } from 'react'
import sanitizeHtml from 'sanitize-html'

import { OrganicCampaignDetailsFilters } from '@src/components/content/organicCampaignDetails/organicCampaignDetailsFilter'
import { ThemeAwareColor } from '@src/lib/theme'

import { CampaignCardTruncatedDescription } from '../CampaignCard'
import { OmniCampaignCard } from '../OmniCampaignCard'

interface PublicShareSettingsCardProps {
  settings: Campaign['share_settings']
  campaignId: Campaign['id']
  shareType: string
  filterApi: OrganicCampaignDetailsFilters
}

const PublicShareSettingsCard: React.FC<PublicShareSettingsCardProps> = (
  props,
) => {
  const filteredResults = useMemo(() => {
    if (props.settings == null) {
      return
    }

    const sorted = [...props.settings]
    sorted.sort((a, b) => {
      if (props.filterApi.debouncedFilterInfo.filter.sortField === 'created') {
        return (
          new Date(a.created_at || '').valueOf() -
          new Date(b.created_at || '').valueOf()
        )
      }

      if (props.filterApi.debouncedFilterInfo.filter.sortField === 'updated') {
        return (
          new Date(a.updated_at || '').valueOf() -
          new Date(b.updated_at || '').valueOf()
        )
      }

      if (props.filterApi.debouncedFilterInfo.filter.sortField === 'name') {
        return (a.name || '').localeCompare(b.name || '')
      }

      if (props.filterApi.debouncedFilterInfo.filter.sortField === 'format') {
        return (
          a.digital_assets?.[0]?.file?.format?.localeCompare(
            b.digital_assets?.[0]?.file?.format || '',
          ) || 0
        )
      }

      return 0
    })

    if (props.filterApi.debouncedFilterInfo.filter.sortDirection === 'desc') {
      return sorted.reverse()
    }

    return sorted
  }, [
    props.filterApi.debouncedFilterInfo.filter.sortDirection,
    props.filterApi.debouncedFilterInfo.filter.sortField,
    props.settings,
  ])

  const channelColor = CHANNEL_COLORS[props.shareType] || 'primary'

  return (
    <>
      <Grid container justifyContent="center" spacing={4}>
        {filteredResults?.map((x) => {
          const description =
            props.shareType === 'email'
              ? sanitizeHtml(x.description || '', { allowedTags: [] })
              : x.description

          return (
            <Grid key={x.id} item xs={12} sm={6} md={6} lg={4}>
              <OmniCampaignCard
                title={x.name}
                description={
                  <CampaignCardTruncatedDescription>
                    {description}
                  </CampaignCardTruncatedDescription>
                }
                mediaPublicId={x.digital_assets?.[0]?.file?.public_id}
                mediaType={x.digital_assets?.[0]?.file?.resource_type}
                actionAreaLabel={I18n.t('shared.share')}
                actionAreaColor={channelColor}
              />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

const CHANNEL_COLORS: Record<string, ThemeAwareColor> = {
  facebook: 'facebook',
  instagram: 'instagram',
  // downloadables: 'downloadables',
  twitter: 'twitter',
  tiktok: 'tiktok',
  // banner: 'banner',
  // email: 'email',
}

export default PublicShareSettingsCard
